@if (message()?.message) {
  <article class="no-print" animate.enter="enter-animation" animate.leave="leaving" [class.warn]="message()?.type == 'warn'" [class.has-details]="message()?.detail">
    <main>
      <div [class.bold]="message()?.detail">{{ message()?.message }}</div>
      <div>{{ message()?.detail }}</div>
    </main>
  </article>
}
